import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

/**
 * AddGroupDialog - Dialog for adding a new organism group
 * 
 * @param {boolean} isOpen - Controls dialog visibility
 * @param {function} onClose - Callback when dialog is closed
 * @param {string} groupName - New group name value
 * @param {function} onGroupNameChange - Callback when group name changes
 * @param {function} onAddClick - Callback when "Legg til gruppe" is clicked
 */
export default function AddGroupDialog({
  isOpen,
  onClose,
  groupName,
  onGroupNameChange,
  onAddClick
}) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onAddClick();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md z-[300]">
        <DialogHeader>
          <DialogTitle>Legg til ny orden/gruppe</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Gruppenavn *</Label>
            <Input
              value={groupName}
              onChange={(e) => onGroupNameChange(e.target.value)}
              placeholder="f.eks. Cryptophyceae"
              className="mt-2"
              onKeyDown={handleKeyDown}
            />
          </div>
          <div className="flex space-x-2">
            <Button 
              onClick={onAddClick} 
              className="flex-1 bg-teal-600 hover:bg-teal-700"
            >
              Legg til gruppe
            </Button>
            <Button 
              variant="outline" 
              onClick={() => {
                onClose(false);
                onGroupNameChange('');
              }} 
              className="flex-1"
            >
              Avbryt
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
